var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewPathArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12l6-6-6-6-1.053 1.053 4.176 4.21H0v1.474h9.123l-4.21 4.21L6 12z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/svg/new-path-arrow.svg";
export { SvgNewPathArrow as ReactComponent };